import { render, staticRenderFns } from "./fichajes_hoy.vue?vue&type=template&id=9c6841ae&scoped=true&"
import script from "./fichajes_hoy.vue?vue&type=script&lang=ts&"
export * from "./fichajes_hoy.vue?vue&type=script&lang=ts&"
import style0 from "./fichajes_hoy.vue?vue&type=style&index=0&id=9c6841ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6841ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
